
















































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly dark: boolean;
  @Prop({ type: Boolean, default: false })
  readonly filled: boolean;
  @Prop({ type: Boolean, default: false })
  readonly dense: boolean;
  @Prop({ type: Boolean, default: false })
  readonly ampmFormat: boolean;
  @Prop({ type: Boolean, default: false })
  readonly required: boolean;
  @Prop({ type: Boolean, default: false })
  readonly readonly: boolean;
  @Prop({ required: false }) readonly label: string;

  @Model('input', { type: String })
  readonly value: string;

  hours: null | string = null;
  minutes: null | string = null;
  ampm = 'am';

  ampmItems = [
    { text: 'AM', value: 'am' },
    { text: 'PM', value: 'pm' },
  ];

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  checkHourInput() {
    if (!this.hours) {
      this.$emit('input', null);
      return;
    }

    if (this.ampmFormat) {
      if (Number(this.hours) > 12 || Number(this.hours) < 1) {
        this.hours = '12';
      }

      let mins = '00';

      if (this.minutes) {
        mins = this.minutes;
      }
      this.$emit(
        'input',
        moment(`${this.hours}:${mins} ${this.ampm}`, 'hh:mm a').format('HH:mm'),
      );
    } else {
      if (Number(this.hours) > 23 || Number(this.hours) < 0) {
        this.hours = '00';
      }

      let mins = '00';

      if (this.minutes) {
        mins = this.minutes;
      }
      this.$emit('input', `${this.hours}:${mins}`);
    }
  }

  checkMinuteInput() {
    if (!this.hours) {
      this.$emit('input', null);
    } else {
      if (Number(this.minutes) > 59 || Number(this.minutes) < 1) {
        this.minutes = '00';
      }

      if (this.ampmFormat) {
        this.$emit(
          'input',
          moment(
            `${this.hours}:${this.minutes} ${this.ampm}`,
            'hh:mm a',
          ).format('HH:mm'),
        );
      } else {
        this.$emit('input', `${this.hours}:${this.minutes}`);
      }
    }
  }

  updateAmpm() {
    if (this.hours && this.minutes) {
      this.$emit(
        'input',
        moment(`${this.hours}:${this.minutes} ${this.ampm}`, 'hh:mm a').format(
          'HH:mm',
        ),
      );
    }
  }

  @Watch('value', { immediate: true })
  valueChanged() {
    if (this.value) {
      this.hours = this.ampmFormat
        ? moment(this.value, 'HH:mm').format('hh')
        : moment(this.value, 'HH:mm').format('HH');
      this.minutes = moment(this.value, 'HH:mm').format('mm');
      this.ampm = moment(this.value, 'HH:mm').format('a');
    } else {
      this.hours = null;
      this.minutes = null;
    }
  }
}
